<template>
  <span class="brand">
    <span class="brand__mark" aria-hidden="true">
      <img
        class="brand__image brand__image--for-dark"
        src="/assets/brand/resicorp-black.webp"
        alt=""
        width="88"
        height="88"
      >
      <img
        class="brand__image brand__image--for-light"
        src="/assets/brand/resicorp-white.webp"
        alt=""
        width="88"
        height="88"
      >
    </span>
    <span class="brand__wordmark">
      <strong>RESI</strong>
      <small>CORPORATION</small>
    </span>
  </span>
</template>
